import { createFcmDetails } from '../shared/factory';

export const FCM_DETAILS_MONETIZATION_BANDIT_COMBO_EXP = createFcmDetails('monetization_bandit_combo_exp', {
	owner: 'Monetization Team',
	context: 'Combo Page',
	description: 'Enables the bandit hard coded experiment',
	import: false,
	template: {
		experiment_name: 'my_experiment_name',
	},
});
